import { MemberStatus } from '../../types';

/** Humanize the member_status enum (e.g. ENROLLED -> Enrolled). */
const getMembershipLabel = (status?: MemberStatus | null): string =>
    status ? status.charAt(0) + status.slice(1).toLowerCase() : 'N/A';

export default getMembershipLabel;
